import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  AbstractValueAccessor,
  MakeProvider,
} from '../../abstracts/abstract-value-accessor';

@Component({
  selector: 'brn-input-preview',
  templateUrl: './input-preview.component.html',
  styleUrls: ['./input-preview.component.scss'],
  providers: [MakeProvider(InputPreviewComponent)],
})
export class InputPreviewComponent extends AbstractValueAccessor {
  @Input('previewText') previewText: string = '';
  @Input('placeholder') placeholder: string = 'Set value…';
  @Input() editEnabled!: boolean;
  @Input() applySuccess?: EventEmitter<boolean>;
  @Output() apply: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('inputField') inputField!: ElementRef;
  prevValue?: string;
  focusTextarea: boolean = false;

  private unsubscribe$: Subject<any> = new Subject();

  edit() {
    setTimeout(() => {
      if (this.editEnabled && !this.focusTextarea) {
        this.prevValue = this.value;
        this.focusTextarea = true;
        setTimeout(
          () =>
            (this.inputField.nativeElement.innerHTML = this.value
              .replaceAll('{{', '<strong>{{')
              .replaceAll('}}', '}}</strong>')),
          0
        );
      }
    }, 0);
  }

  applyChanges() {
    if (this.focusTextarea) {
      this.value = this.inputField.nativeElement.innerHTML
        .replaceAll('<strong>{{', '{{')
        .replaceAll('}}</strong>', '}}');
      this.apply.emit(this.value);
      this.prevValue = undefined;
      if (this.applySuccess) {
        this.applySuccess
          .pipe(takeUntil(this.unsubscribe$), take(1))
          .subscribe((result) => {
            if (result) {
              this.focusTextarea = false;
            }
          });
      } else {
        this.focusTextarea = false;
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
